module.exports = __webpack_public_path__ + "static/media/logo_nodos.0cb139d9.png";